/**
 * @fileoverview
 * context: Mastercard has 2 main data centers, (St. Louis and Kansas City)
 * that work together. One can be taken offline, deployed to and safely
 * tested while the other continues processing. When testing is complete,
 * the data center can be brought make online and continue co-processing.
 *
 * To determine which data center to route traffic to, the front end needs to
 * 1. send a GET request to <env>.src.mastercard.com/s/tag to retrieve a tag.
 *     ex response: data: { mc_s_id: 'bef23d6' }
 * 2. Add a request Header to all subsequent calls
 *     ex header: mc_s_id => "bef23d6"
 */

import axios from 'axios'

const akamai = {
  /**
   * Fetches the akamai tag and sets it as s default header in axios
   *
   * @async
   * @returns tag value
   */
  async getTag() {
    try {
      const { data } = await axios.get('/s/tag')
      const tag = data && data.mc_s_id

      if (tag) {
        axios.defaults.headers.mc_s_id = tag
      }

      return tag
    } catch (error) {
      // Do nothing and continue with program execution since the mc_s_id
      // is not essential to the functionality of our app as a whole.
    }
  }
}

export default akamai
